import { NotificationConfig } from "../../../../../../../../service/reportFolio/response";


const formatNotificationResponse = ({ response }: { response: NotificationConfig }) => {

  const notification: NotificationConfig = response ? {
    email: response.email,
    app: response.app,
    frequencyType: response.frequencyType,
    daysOfWeek: response.daysOfWeek,
    time: response.time,
    id: response.id
  }:null 


  return {
    notification
  }
}


export { formatNotificationResponse }